// src/components/TeamSection.jsx
import React, { useState } from "react";
import { Card, Button, Modal } from "react-bootstrap";
import "../assets/css/TeamSection.css";

import member1 from "../assets/images/Team/Mr.-Somen-Banerjee.jpg";
import member2 from "../assets/images/Team/Mr.-Neehar-Gandhi.jpg";
import member3 from "../assets/images/Team/Mrs.-Vaishali-Banerjee-480x719.jpg";
import member4 from "../assets/images/Team/Mr.-Nailesh-Gandhi-480x719.jpg";

// Team member data
const teamData = [
  {
    img: member1,
    name: "Mr. Somen Banerjee",
    role: "CMD",
    bio: "Driven in a Chariot of Aspirations, Mr. Somen Banerjee embarked on his journey to challenge conventional wisdom; a road less traveled and a vision construed by a Few. His dauntless entrepreneurial skills free him from the conformity of others. Cladded in the armor of morality and virtues, he set ablaze the trail for many to follow. He states that the organization is the essence of his entity and his only true identity.He has transcended all ethnic boundaries and aims to provide a platform and a forum for industry professionals to cascade and percolate their research and expertise He is Au Courant with the latest advancement and endeavors to explore myriads ways to find solutions to medical challenges. His acumen, his selfless commitment, his prowess, and his audacity is only directed toward his vision and mission in life.",
  },
  
  {
    img: member3,
    name: "Mrs. Vaishali Banerjee",
    role: "Business Head",
    bio: "Mrs. Vaishali Banerjee, a nature enthusiast; believes that a plethora of wealth pertaining to health can be offered to the world by selflessly working towards the objective. Firmly holding to her convictions that life on earth should be valued and cared for; exhorts that collective measures must be taken towards enhancing and nurturing it She reinstates that reformation and transition come only through education and cascading the learnings to the society at large. Hence innovative measures and initiatives must be made to meet our requisition. An ardent and voracious reader, she finds solace in the wellspring of wisdom; the books, and believes that virtues are nurtured through value education She shares the same dream envisioned by Mr. Somen Banerjee and has ever since worked in sync with the mission and is in a constant endeavor to expedite the process. She is also responsible for spearheading several initiatives that have propelled the organization to transcend various dimensions of health with a goal to accentuate and preserve life.",
  },
  {
    img: member4,
    name: "Mr. Nailesh Gandhi",
    role: "Chief Financial Officer",
    bio: "Mr. Nailesh Gandhi, a man of few words, a true comrade; is a sum of integrity and devotion to the organization, always supporting the mission envisioned by Mr. Somen Banerjee. Holding the reins of the financial department, He is known for his warm hospitality and gentleness across the industry. He firmly believes that our ethics and values need to be preserved and protected, fostered and firmed, strengthened and established. A seamless blend of simplicity and Sensitivity, he has managed to etch his way into the hearts of many.",
  },
  {
    img: member2,
    name: "Neehar Gandhi",
    role: "Director of Sales & Marketing",
    bio: "An exemplification of Integrity, Gentleness, and Discipline. Marking the youth of today Mr. Neehar Gandhi with his sauve demeanor leaves no stone unturned to draw the dream to Fruition. He does not deter from belling the cat in times of pressing situations. His chivalrous and obliging mannerism has won many hearts and is truly revered by his team mates. He believes in the principle that our virtues make up the fabric of our life.",
  },
];

const TeamSection = () => {
  const [show, setShow] = useState(false);
  const [activeMember, setActiveMember] = useState(null);

  const handleOpen = (member) => {
    setActiveMember(member);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setActiveMember(null);
  };

  return (
    <section className="team-section" data-aos="fade-up">
      <div className="container">
        <h2 className="text-center mb-5">
          Meet Our <span className="highlight">Expert Team</span>
        </h2>

        <div className="row">
          {teamData.map((member, index) => (
            <div className="col-lg-3 col-md-6 mb-4" key={index}>
              <Card className="team-card h-100">
                <div className="card-img-wrapper">
                  <Card.Img variant="top" src={member.img} />
                </div>

                <Card.Body className="d-flex flex-column">
                  <Card.Title className="mb-1">{member.name}</Card.Title>
                  <Card.Subtitle className="mb-3 text-muted">
                    {member.role}
                  </Card.Subtitle>
                  <Card.Text className="flex-grow-1">
                    {member.bio.length > 120
                      ? member.bio.slice(0, 110) + "..."
                      : member.bio}
                  </Card.Text>

                  <div className="mt-3">
                    <Button
                      className="btn-gradient"
                      onClick={() => handleOpen(member)}
                    >
                      Read More
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      <Modal
        show={show}
        onHide={handleClose}
        centered
        dialogClassName="custom-modal-dialog"
        contentClassName="custom-modal-content"
      >
        <button type="button" className="modal-close-btn" onClick={handleClose}>
          ×
        </button>

        {activeMember && (
          <div className="modal-body-wrapper">
            <div className="modal-left">
              <img
                src={activeMember.img}
                alt={activeMember.name}
                className="modal-member-img"
              />
            </div>

            <div className="modal-right">
              <h4 className="modal-name">{activeMember.name}</h4>
              <h6 className="modal-role">{activeMember.role}</h6>
              <p className="modal-bio">{activeMember.bio}</p>
            </div>
          </div>
        )}
      </Modal>
    </section>
  );
};

export default TeamSection;
